import { axios } from "@/core/axios";
import type { Level, Metric, Product, Segment, Service } from "../types";

const buildQueryString = (params: Record<string, string | number | undefined>) => {
  const query = Object.entries(params)
    .filter(([, value]) => value !== undefined)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join("&");

  return query ? `?${query}` : "";
};

const includeRelations = (relations: readonly string[] = []) =>
  relations.length ? { include: relations.join(",") } : {};

export const productEndpoints = {
  listProducts: async (relations: readonly string[] = []): Promise<Product[]> => {
    const query = buildQueryString(includeRelations(relations));
    const response = await axios.get<Product[]>(`/products${query}`);
    return response.data;
  },

  listServices: async (
    productId?: number,
    relations: readonly string[] = [],
  ): Promise<Service[]> => {
    const query = buildQueryString({ ...includeRelations(relations), productId });
    const response = await axios.get<Service[]>(`/services${query}`);
    return response.data;
  },

  listLevels: async (
    serviceId?: number,
    relations: readonly string[] = [],
  ): Promise<Level[]> => {
    const query = buildQueryString({ ...includeRelations(relations), serviceId });
    const response = await axios.get<Level[]>(`/levels${query}`);
    return response.data;
  },

  listSegments: async (
    levelId?: number,
    relations: readonly string[] = [],
  ): Promise<Segment[]> => {
    const query = buildQueryString({ ...includeRelations(relations), levelId });
    const response = await axios.get<Segment[]>(`/segments${query}`);
    return response.data;
  },

  listMetrics: async (
    serviceId?: number,
    relations: readonly string[] = [],
  ): Promise<Metric[]> => {
    const query = buildQueryString({ ...includeRelations(relations), serviceId });
    const response = await axios.get<Metric[]>(`/metrics${query}`);
    return response.data;
  },
};
